import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonGridService } from 'src/app/Services/Common/grid.service';
import { AlertDialogService } from 'src/app/Services/Alert/alert.service';
import { CommonService } from 'src/app/Services/Common/common.service';
import { PatternService } from 'src/app/Services/Pattern-Service/pattern.service';
import { HttpRequestService } from 'src/app/Services/Http/http-request.service';
import { PropertiesService } from 'src/app/Services/Properties/properties.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { SearchService } from 'src/app/Services/search.service';
import { MatDialog } from '@angular/material';
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { jqxTabsComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxtabs';

declare var $: any;

@Component({
  selector: 'app-cmaster',
  templateUrl: './cmaster.component.html',
  styleUrls: ['./cmaster.component.css']
})
export class CMasterComponent implements OnInit {
  uri = this.property.WebAPIipAndPort.concat(this.property.BSSAPI);
  today = new Date();
  minDate = this.today;
  maxDate = this.today;
  commodityId = 0;
  customerMasterForm: FormGroup;
  addressTypeIdComboAddapter: any;
  imageUploadDetailsColumns: any;
  imageUploadDetailsSource: any;
  imageUploadDetailsDataAdapter: any;
  gateInContSealImagePopupRenderToolBar: any;
  gstDisabled: boolean = false;
  AddressFlag: boolean = true;
  StateFlag: boolean = true;
  GstFlag: boolean = true;
  isSalesPersonRequired: number = 0;



  localUrl: any[];
  imageUploadForm: FormGroup;
  IsCodeComboAdapter: any;
  IsCodeComboList: any;
  Files: any[];
  fileUrl;
  deletedObjects = [];

  termCodeList: any;
  temaAddressRow: number = 0;
  BookCategoryList: any;
  TDSList: any;
  gstFVALUE: string = '';
  gstFVALUEMaxLength: string = '15';
  constructor(private formBuilder: FormBuilder,
    private gridService: CommonGridService,
    private alert: AlertDialogService,
    public commonService: CommonService,
    private pattern: PatternService,
    private httpRequestService: HttpRequestService,
    private property: PropertiesService,
    private http: HttpClient,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private router: Router,
    private activateRouter: ActivatedRoute,
    private searchService: SearchService,



    // public showContainer:boolean = false,
    public dialog: MatDialog
  ) {

    this.createForm();


  }
  masteruri = this.property.WebAPIipAndPort.concat(this.property.BSSAPI);
  bonduri = this.property.WebAPIipAndPort.concat(this.property.BSSAPI);
  createdId: number = this.property.userId;
  createdMacAddress: string = this.property.macAddress;
  modifiedId: number = this.property.userId;
  modifiedMacAddress: string = this.property.macAddress;
  currentOuId: number = this.property.ouId;

  containerGridColumns: any;
  containerGridDataAdapter: any;
  commodityGridColumns: any;
  commodityGridDataAdapter: any;
  addressGridColumns: any;




  invoiceGridColumns: any;
  invoiceGridDataAdapter: any;
  addressGridDataAdapter: any;

  commodityClassComboAdapter: any;
  commodityGroupComboAdapter: any;
  quantityComboAdapter: any;
  weightComboAdapter: any;
  invoiceNoComboAdapter: any;
  containerSizeComboAdapter: any
  containerTypeComboAdapter: any
  addressGridToolBar: any;
  ctryName: string;





  consTypeList: any[] = [];
  impAddressList: any[] = [];
  chaAddressList: any[] = [];
  containerSizeComboList: any[] = [];
  containerTypeComboList: any[] = [];
  commodityClassComboList: any[] = [];
  commodityGroupComboList: any[] = [];
  quantityComboList: any[] = [];
  weightComboList: any[] = [];
  containerGridToolBar: any;
  containerColumns: any[];
  containerSource: any;
  addressSource: any;
  gstSource: any;


  invoiceGridToolBar: any;
  commodityColumns: any[];
  invoiceSource: any;
  commodityGridToolBar: any;
  invoiceColumns: any[];
  commoditySource: any;
  storageSpaceUOMList: any;
  // bwhIdList: any;
  // bwhTypeIdList: any;
  importerDependFields = ['IMPORTER']
  chaDependFields = ['CHA']
  mblHblDialouge;
  inBondNoDialouge: any;
  boeNoDialouge: any;
  igmNoDialouge: any;
  igmDateDialouge: any;
  mblNoDialouge: any;
  mLineNoDialouge: any;
  challanDialouge: any;
  voyageNoDialouge: any;
  viaNoDialouge: any;
  assessableValueDialouge: any;
  dutyAmountDialouge: any;
  storagePeriodDialouge: any;
  isBankCodeShow: boolean = true;
  pageId: any;
  progressBarShow: boolean = false;
  clearButton: boolean = false;
  editButton: boolean = false;
  cancelButton: boolean = false;
  isWithBoe;
  navigationSubscription;
  cancelRemarks: string;
  popUpTitle: string;
  jobNo: string;
  editedRowCommodityGrid: Map<Number, Object>;
  editedRowContainerGrid: Map<Number, Object>;
  editedRowInvoiceGrid: Map<Number, Object>;
  deleteCommodityDetails: any = [];
  deleteContainerDetails: any = [];
  deleteInvoiceDetails: any = [];
  isContainer;
  @Input()
  accept




  @ViewChild('addressGrid1', { static: false }) addressGrid1: jqxGridComponent;
  // @ViewChild('customerMasterTab', null) customerMasterTab: jqxTabsComponent;
  @ViewChild('imageUploadDetailsGrid', { static: false }) imageUploadDetailsGrid: jqxGridComponent;

  @ViewChild('fileUpload', { static: false })
  fileUpload: ElementRef

  @Input()
  files: File[] = []

  onClick(event) {
    if (this.fileUpload)
      this.fileUpload.nativeElement.click()
  }

  onFileSelected(event) {
    let files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
    console.log('event::::::', event)
    this.imageUpload(files);
    event.target.value = "";
  }

  onInput(event) {

  }

  imageUpload(file) {
    var formData = new FormData();
    for (let i = 0; i < file.length; i++) {
      formData.append('image', file[i]);
      formData.append('jobNo', "CKYC");
    }
    // let header = new HttpHeaders({
    //   'Content-Type': 'multipart/form-data',
    // });

    let imageExist = $(".imageUploadDetailsGrid").jqxGrid('getboundrows');
    // imageExist.forEach(element => {
    //   if(!element.FileName){
    //   response.DocumentID = element.DocumentID;
    //   response.codeName = element.codeName;
    //   response.DocRefNumber = element.DocRefNumber;
    //   }
    // });

    this.http.post(this.uri + "/imageUpload/uploadFile", formData).subscribe((response: any) => {
      if (response) {
        let imageExist = $(".imageUploadDetailsGrid").jqxGrid('getboundrows');
        let row = $(".imageUploadDetailsGrid").jqxGrid('getselectedrowindex');
        let edit = $(".imageUploadDetailsGrid").jqxGrid('getrowdata', row);
        var existFile = imageExist.filter((exist) => {
          if (exist.FileName) {
            if (edit) {
              return exist.FileName === edit.FileName;
            }
          }
        });
        imageExist.forEach(element => {
          if (!element.FileName) {
            if (existFile.length === 0) {
              // response[0].DocumentID = element.DocumentID;
              // response[0].codeName = element.codeName;
              // response[0].DocRefNumber = element.DocRefNumber;
              element.FileName = response[0].FileName ? response[0].FileName : '';
              element.StoredFileName = response[0].StoredFileName ? response[0].StoredFileName : '';
            }
          }
        });
        imageExist.forEach(eleme => {
          if (existFile.length > 0) {
            if (eleme.FileName == existFile[0].FileName) {
              eleme.FileName = response[0].FileName ? response[0].FileName : '';
              eleme.StoredFileName = response[0].StoredFileName ? response[0].StoredFileName : '';
            }
          }
        });
        // this.imageUploadDetailsGrid.addrow(null, imageExist);
        // this.imageUploadDetailsGrid.addrow(null, imageExist);
        // this.imageUploadDetailsGrid.addrow(null, response);

        this.imageUploadDetailsSource.localdata = imageExist
        this.imageUploadDetailsDataAdapter = new jqx.dataAdapter(this.imageUploadDetailsSource);
        $(".imageUploadDetailsGrid").jqxGrid('updatebounddata');
      } else if (!response) {
        this.alert.openSnackBar('Error Occured While Save Image Upload', '');
      }
    }, (error: any) => {
      console.log('imageUpload save Error Occured', error);
    });
  }

  ngOnInit() {
    // this.router.navigate(['/home', { outlets: { search: ['searchCustomer'] } }]);
    this.createForm();
    // this.setFieldLables();
    // this.addressGridInit();
    // this.getAddressTypeId();
    // this.getTOSMasterForGrid();
    // this.cargoDamageDetailsGrid();
    // this.getCodeCombo();
    // this.getBookCategoryList();

    // this.route.queryParams.subscribe(params => {
    //   if (params.CustomerId) {
    //     this.customerMasterForm.disable();
    //     $(".addressGrid1").jqxGrid({ disabled: true });
    //     $(".imageUploadDetailsGrid").jqxGrid({ disabled: true });
    //     this.customerMasterForm.get("CustomerId").setValue(params.CustomerId);
    //     this.customerMasterForm.get("CuName").setValue(params.CuName);

    //     this.customerMasterForm.get("CountryId").setValue(params.CountryId ? Number(params.CountryId) : '');
    //     if (params.isActive == 'true') {
    //       this.customerMasterForm.get("isActive").setValue(true);
    //     } else {
    //       this.customerMasterForm.get("isActive").setValue(false);
    //     }
    //     this.customerMasterForm.get("isCustomer").setValue(false);
    //     this.customerMasterForm.get("isOMSAgent").setValue(false);
    //     this.customerMasterForm.get("isShipper").setValue(false);
    //     this.customerMasterForm.get("isForwarder").setValue(false);
    //     this.customerMasterForm.get("isCha").setValue(false);
    //     this.customerMasterForm.get("isLiner").setValue(false);
    //     this.customerMasterForm.get("isTransporter").setValue(false);
    //     this.customerMasterForm.get("isTrader").setValue(false);
    //     this.customerMasterForm.get("isAgent").setValue(false);
    //     this.customerMasterForm.get("isBank").setValue(false);
    //     this.customerMasterForm.get("isConsignee").setValue(false);
    //     this.customerMasterForm.get("isNotifier").setValue(false);
    //     this.customerMasterForm.get("isContract").setValue(false);
    //     this.customerMasterForm.get("isDomesticVendor").setValue(false);
    //     this.customerMasterForm.get("isWarehouse").setValue(false);
    //     this.customerMasterForm.get("isImportShipper").setValue(false);
    //     this.customerMasterForm.get("isImportConsignee").setValue(false);
    //     this.customerMasterForm.get("isImportNotifier").setValue(false);

    //     var val1 = params.CuType;
    //     var chars = val1.split(',');
    //     for (var i = 0; i < chars.length; i++) {
    //       if (chars[i] == 1396) {
    //         this.customerMasterForm.get("isCustomer").setValue(true);
    //       }
    //       if (chars[i] == 1412) {
    //         this.customerMasterForm.get("isOMSAgent").setValue(true);
    //       }
    //       if (chars[i] == 214) {
    //         this.customerMasterForm.get("isForwarder").setValue(true);
    //       }
    //       if (chars[i] == 16) {
    //         this.customerMasterForm.get("isCha").setValue(true);
    //       }
    //       if (chars[i] == 216) {
    //         this.customerMasterForm.get("isLiner").setValue(true);
    //       }
    //       if (chars[i] == 20) {
    //         this.customerMasterForm.get("isTransporter").setValue(true);
    //       }
    //       if (chars[i] == 220) {
    //         this.customerMasterForm.get("isTrader").setValue(true);
    //       }
    //       if (chars[i] == 332) {
    //         this.customerMasterForm.get("isAgent").setValue(true);
    //       }
    //       if (chars[i] == 222) {
    //         this.customerMasterForm.get("isBank").setValue(true);
    //       }
    //       if (chars[i] == 372) {
    //         this.customerMasterForm.get("isConsignee").setValue(true);
    //       }
    //       if (chars[i] == 373) {
    //         this.customerMasterForm.get("isNotifier").setValue(true);
    //       }
    //       if (chars[i] == 376) {
    //         this.customerMasterForm.get("isContract").setValue(true);
    //       }
    //       if (chars[i] == 389) {
    //         this.customerMasterForm.get("isDomesticVendor").setValue(true);
    //       }
    //       if (chars[i] == 390) {
    //         this.customerMasterForm.get("isWarehouse").setValue(true);
    //       }
    //       if (chars[i] == 1393) {
    //         this.customerMasterForm.get("isImportShipper").setValue(true);
    //       }
    //       if (chars[i] == 1394) {
    //         this.customerMasterForm.get("isImportConsignee").setValue(true);
    //       }
    //       if (chars[i] == 1395) {
    //         this.customerMasterForm.get("isImportNotifier").setValue(true);
    //       }
    //       if (chars[i] == 31) {
    //         this.customerMasterForm.get("isShipper").setValue(true);
    //       }
    //     }
    //     this.GetCustomerData(params.CustomerId);
    //   }
    // });
  }
  setFieldLables() {
    this.getFLData().then((list: any) => {
      console.log(list.result);
      this.gstFVALUE = list.result[0].FValue1;
      this.gstFVALUEMaxLength = list.result[0].FLength1;
      if (!list.result[0].lblFactoring || list.result[0].lblFactoring == '') {
        this.isBankCodeShow = true;
      } else {
        this.isBankCodeShow = false;
      }
    });
  }

  getFLData() {
    return new Promise((resolve, reject) => {
      this.httpRequestService.get(this.uri + "/fieldLabel/getFieldLabel?FType=Customer master GST&Country=&Branch=" + this.property.branchCode + "&Currency=" + this.property.branchCurrency + "&CustomerID=" + this.property.userId)
        .then((res: any) => {
          // console.log('response', res);
          if (res.status == 200) {
            resolve(res);
          }
        }, (error) => {
          reject(error);
        });
    });
  }
  GetCustomerData(customerId) {
    // alert(customerId);
    this.GetCustomer(customerId).then((list: any) => {
      this.progressBarShow = false;
      list.result[1].forEach(address => {
        if (address.isSEZ == true) {
          address.isSEZ = 1;
        } else {
          address.isSEZ = 0;
        }
      });
      this.addressSource.localdata = list.result[1];
      this.addressGridDataAdapter = new $.jqx.dataAdapter(this.addressSource);
      $(".addressGrid1").jqxGrid('updatebounddata');

      this.imageUploadDetailsSource.localdata = list.result[2]
      this.imageUploadDetailsDataAdapter = new jqx.dataAdapter(this.imageUploadDetailsSource);
      $(".imageUploadDetailsGrid").jqxGrid('updatebounddata');

      this.customerMasterForm.get("CountryId").setValue(list.result[0][0].CountryId ? Number(list.result[0][0].CountryId) : '');
      this.customerMasterForm.get("Country").setValue(list.result[0][0].Country);
      // if (list.result[0][0].Country == "INDIA") {
      //   this.gstDisabled = false;
      // } else {
      //   this.gstDisabled = true;
      // }
      this.gstDisabled = false;
      this.customerMasterForm.get("CreditDays").setValue(list.result[0][0].CreditDays);
      this.customerMasterForm.get("GST").setValue(list.result[0][0].GST);
      this.customerMasterForm.get("TDSID").setValue(list.result[0][0].TDSID);
      this.customerMasterForm.get("TDSPer").setValue(list.result[0][0].TDSPer);
      this.customerMasterForm.get("TermCode").setValue(list.result[0][0].TermCode ? Number(list.result[0][0].TermCode) : '');
      this.customerMasterForm.get("isActive").setValue(Number(list.result[0][0].isActive) ? true : false);

      this.customerMasterForm.get("BaseCurrency").setValue(list.result[0][0].BaseCurrency);
      this.customerMasterForm.get("AcOprPerson").setValue(list.result[0][0].AcOprPerson);
      this.customerMasterForm.get("SplAccounts").setValue(list.result[0][0].SplAccounts);
      this.customerMasterForm.get("BillSubLedger").setValue(list.result[0][0].BillSubLedger);
      this.customerMasterForm.get("GstExempted").setValue(list.result[0][0].GstExempted);

      if (list.result[0][0].EffectiveDt == "1900-01-01") {
        this.customerMasterForm.get("EffectiveDt").setValue('');
      } else {
        this.customerMasterForm.get("EffectiveDt").setValue(list.result[0][0].EffectiveDt);
      }
      this.customerMasterForm.get("TaxIdNo").setValue(list.result[0][0].TaxIdNo);
      this.customerMasterForm.get("TDSPercentage").setValue(list.result[0][0].TDSPercentage);
      this.customerMasterForm.get("Note").setValue(list.result[0][0].Note);
      this.customerMasterForm.get("ProfitShare").setValue(list.result[0][0].ProfitShare);
      this.customerMasterForm.get("FSCBilling").setValue(list.result[0][0].FSCBilling);
      this.customerMasterForm.get("EDirect").setValue(list.result[0][0].EDirect);
      this.customerMasterForm.get("EExport").setValue(list.result[0][0].EExport);
      this.customerMasterForm.get("EImport").setValue(list.result[0][0].EImport);
      this.customerMasterForm.get("EAutoOS").setValue(list.result[0][0].EAutoOS);
      this.customerMasterForm.get("ETranshipment").setValue(list.result[0][0].ETranshipment);
      this.customerMasterForm.get("EExportstatus").setValue(list.result[0][0].EExportstatus);
      this.customerMasterForm.get("EImportstatus").setValue(list.result[0][0].EImportstatus);
      this.customerMasterForm.get("BankName").setValue(list.result[0][0].BankName);
      this.customerMasterForm.get("AccountNo").setValue(list.result[0][0].AccountNo);
      this.customerMasterForm.get("AccountName").setValue(list.result[0][0].AccountName);
      this.customerMasterForm.get("AcType").setValue(String(list.result[0][0].AcType));
      this.customerMasterForm.get("IFSC").setValue(list.result[0][0].IFSC);
      this.customerMasterForm.get("SwiftNo").setValue(list.result[0][0].SwiftNo);
      this.customerMasterForm.get("RoutingNo").setValue(list.result[0][0].RoutingNo);
      this.customerMasterForm.get("PaymentType").setValue(String(list.result[0][0].PaymentType));
      this.customerMasterForm.get("BankAddress").setValue(list.result[0][0].BankAddress);
      this.customerMasterForm.get("BeneficiaryName").setValue(list.result[0][0].BeneficiaryName);
      this.customerMasterForm.get("BenAcNo").setValue(list.result[0][0].BenAcNo);
      this.customerMasterForm.get("BenAcType").setValue(String(list.result[0][0].BenAcType));
      this.customerMasterForm.get("BenAddress").setValue(list.result[0][0].BenAddress);
      this.customerMasterForm.get("BenMobile").setValue(list.result[0][0].BenMobile);
      this.customerMasterForm.get("CurrencyId").setValue(list.result[0][0].CurrencyId);
      this.customerMasterForm.get("Currency").setValue(list.result[0][0].Currency);
      this.customerMasterForm.get("SalesPersonName").setValue(list.result[0][0].SalerPeronName);
      this.customerMasterForm.get("SalesPersonID").setValue(list.result[0][0].SalesPersonID);
      this.customerMasterForm.get("HandleByName").setValue(list.result[0][0].HandleByName);
      this.customerMasterForm.get("HandleByID").setValue(list.result[0][0].HandleByID);
      this.customerMasterForm.get("BookCategory").setValue(list.result[0][0].BookCategory);
      this.customerMasterForm.get("BankCode").setValue(list.result[0][0].BankCode);
      this.customerMasterForm.get("isFactoring").setValue(Number(list.result[0][0].isFactoring) ? true : false);

    });
  }

  onCategorySelected(event) {

    this.BookCategoryList.forEach(element => {
      if (event.value == element.Value) {
        if (element.Label == 'Freehand') {
          this.isSalesPersonRequired = 1;
        } else {
          this.isSalesPersonRequired = 0;
        }
        //this.invoiceForm.get("GST").setValue(element.GST);
      }
    });
  }

  GetCustomer(customerId) {
    this.progressBarShow = true;
    return new Promise((resolve, reject) => {
      this.httpRequestService.get(this.masteruri + "/customer/getCustomer?searchText=" + customerId)
        .then((res: any) => {
          if (res.status == 200) {
            resolve(res);
          }
        }, (error) => {
          reject(error);
        });
    });
  }

  setStep(index: number) {
    $(".collapse" + index).removeClass('fa-plus');
    $(".collapse" + index).addClass('fa-minus');

  }
  setClose(index: number) {
    $(".collapse" + index).removeClass('fa-minus');
    $(".collapse" + index).addClass('fa-plus');
  }
  getTOSMasterForGrid() {
    return new Promise((resolve) => {
      this.http.get(this.masteruri + '/item-activity/combo', { params: { value: "CUS-PAY-TERM" } }).subscribe((res: any) => {
        console.log('Response', res.body);
        if (res != null) {
          resolve(res.body);
          this.termCodeList = res.result
        }
        else {
          alert("No Records Found")
        }
        console.log('Done');
      });
    });
  }
  createForm() {
    this.customerMasterForm = this.formBuilder.group({
      CustomerId: ['', []],
      CuName: ['', [Validators.required]],
      CountryId: ['', []],
      Country: ['', []],
      TermCode: ['', []],
      CreditDays: ['', []],
      GST: ['', []],
      isActive: ['', []],
      BaseCurrency: [],
      AcOprPerson: ['', []],
      SplAccounts: ['', []],
      BillSubLedger: ['', []],
      GstExempted: ['', []],
      EffectiveDt: ['', []],
      TaxIdNo: ['', []],
      TDSPercentage: ['', []],
      Note: ['', []],
      ProfitShare: ['', []],
      FSCBilling: ['', []],
      EDirect: ['', []],
      EExport: ['', []],
      EImport: [''],
      EAutoOS: ['', []],
      ETranshipment: ['', []],
      EExportstatus: ['', []],
      EImportstatus: ['', []],
      BankName: ['', []],
      AccountNo: ['', []],
      AccountName: ['', []],
      AcType: ['', []],
      IFSC: ['', []],
      SwiftNo: ['', []],
      RoutingNo: ['', []],
      CurrencyId: ['', []],
      Currency: ['', []],
      PaymentType: ['', []],
      BankAddress: ['', []],
      BeneficiaryName: ['', []],
      BenAcNo: ['', []],
      BenAcType: ['', []],
      BenAddress: ['', []],
      BenMobile: ['', []],
      isCustomer: ['', []],
      isOMSAgent: ['', []],
      isShipper: ['', []],
      isForwarder: ['', []],
      isCha: ['', []],
      isLiner: ['', []],
      isTransporter: ['', []],
      isTrader: ['', []],
      isAgent: ['', []],
      isBank: ['', []],
      upload: [''],
      SalesPersonID: ['', []],
      SalesPersonName: ['', []],
      isConsignee: ['', []],
      isNotifier: ['', []],
      isContract: ['', []],
      isDomesticVendor: ['', []],
      isWarehouse: ['', []],
      HandleByID: ['', []],
      HandleByName: ['', []],
      txtAddress: [],
      BookCategory: ['', []],
      isImportShipper: ['', []],
      isImportConsignee: ['', []],
      isImportNotifier: ['', []],
      BankCode: ['', []],
      isFactoring: ['', []],
      TDSID: ['', []],
      TDSPer: [],
    });

  }

  getBookCategoryList() {
    return new Promise((resolve) => {
      this.http.get(this.masteruri + '/item-activity/combo', { params: { value: "BOOK CATEGORY2" } }).subscribe((res: any) => {
        console.log('Response', res.body);
        if (res != null) {
          resolve(res.body);
          this.BookCategoryList = res.result;
          this.getTDSList();
        }
        else {
          alert("No Records Found")
        }
        console.log('Done');
      });
    });
  }

  getTDSList() {
    return new Promise((resolve) => {
      this.http.get(this.masteruri + '/item-activity/combo', { params: { value: "TDS" } }).subscribe((res: any) => {
        console.log('Response', res.body);
        if (res != null) {
          resolve(res.body);
          this.TDSList = res.result
        }
        else {
          alert("No Records Found")
        }
        console.log('Done');
      });
    });
  }

  edit() {
    this.customerMasterForm.enable();
    $(".addressGrid1").jqxGrid({ disabled: false });
    $(".imageUploadDetailsGrid").jqxGrid({ disabled: false });
  }

  clear() {
    this.customerMasterForm.reset();
    this.customerMasterForm.enable();
    $(".addressGrid1").jqxGrid('clear');
    $(".addressGrid1").jqxGrid({ disabled: false });
    $(".imageUploadDetailsGrid").jqxGrid('clear');
    $(".imageUploadDetailsGrid").jqxGrid({ disabled: false });
    this.addressGridInit();
    this.customerMasterForm.reset();
    $(".imageUploadDetailsGrid").jqxGrid("addrow", 0, this.addImageNewRow(this));
    this.gstDisabled = true;
  }

  public currencyParams(value) {
    return new Promise((res) => {
      res({ searchText: value });
    });
  }

  htmlEntities(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  stripHTML(str) {
    var strippedText = $("<div/>").html(str).text();
    return strippedText;
  }

  AddressCheckGridMondatory(gridClassName, dataField: any, grid: jqxGridComponent) {
    console.log(dataField);
    let columnLength = dataField.length;
    let flag = true;
    var totalRows = $(gridClassName).jqxGrid('getrows').length;
    // let Rows = $(gridClassName).jqxGrid("getboundrows");
    for (var x = 0; x < Number(totalRows); x++) {
      var data = $('.addressGrid1').jqxGrid('getrowdata', x);
      if (data.AddressTypeName) {
        for (var i = 0; i < Number(columnLength); i++) {

          var AddressTypeName = data["AddressTypeName"];
          var columnData = data[dataField[i]];
          // var isEdited = Rows[x]['rowEdit'];
          if (AddressTypeName) {
            x + 1;
            if (columnData == undefined || columnData == "") {
              var column = $(gridClassName).jqxGrid('getcolumn', dataField[i]);
              var columnName = column.text.indexOf('<') != -1 ? column.text.substr(0, column.text.indexOf('<')) : column.text;
              this.alert.openSnackBar(columnName + "Field is required On Address Tab Row No : " + (x + 1), '');
              flag = false;
              return flag;
            } else {
              flag = true;
            }
          }
        }

      }

    }
    return flag;
  }


  addressGridInit() {
    var checkbox;
    var compScope = this;
    let stateurl = this.masteruri + '/state/autoComplete/stateName';
    let countryurl = this.masteruri + '/country/auto-complete';
    let stateNameLabelInput: any;
    let countryNameLabelInput: any;
    var cellStyle = '';
    var scope = this;
    this.addressGridColumns = [

      {
        text: 'S.No', width: 40, height: 80, sortable: false, datafield: 'sNo', editable: false, menu: false, cellsrenderer: function (row, cell, value) {
          return '<div style="text-align: center; margin-top: 20%;">' + (1 + row) + '</div>';
        }
      },
      { text: 'CuDetailId', hidden: true, datafield: 'CuDetailId' },
      { text: 'CustomerId', hidden: true, datafield: 'CustomerId' },
      { text: 'isActive', hidden: true, datafield: 'isActive' },
      { text: 'Branch', hidden: true, datafield: 'Branch',width: '13%' },
      {
        text: 'Address Type <span style="color:red">*</span>', datafield: 'AddressType', width: '13%', height: 80, displayfield: 'AddressTypeName', columntype: 'dropdownlist', dropDownWidth: 200, hidden: true,
        createeditor: (row: number, value: any, editor: any): void => {
          editor.jqxDropDownList({
            source: this.addressTypeIdComboAddapter,
            displayMember: 'Label',
            valueMember: 'Value',
            autoDropDownHeight: this.addressTypeIdComboAddapter.records.length > 10 ? false : true
          });
        }
      },
      {
        text: 'Address', datafield: 'Address', width: '25%', height: 100, columntype: 'custom', editable: false,

        // createeditor: function (row, cellvalue, editor, cellText, width, height) {
        //   var textarea = $("<textarea />").prependTo(editor);
        //   textarea.jqxEditor({
        //     height: 200,
        //     width: width,
        //     editable: true,
        //     tools: '',
        //     pasteMode: 'text'
        //   });
        // },
        // initeditor: function (row, cellvalue, editor, cellText, width, height) {
        //   var textarea = $("<textarea />").prependTo(editor);
        //   textarea.jqxEditor({
        //     height: '150px',
        //     width: '100%',
        //     editable: true,
        //     tools: '',
        //     pasteMode: 'text',
        //   });
        //   editor.attr('maxlength', 150)
        //   textarea.jqxEditor('val', cellvalue);
        //   setTimeout(function () {
        //     textarea.jqxEditor('focus');
        //   }, 5);
        // },
        // geteditorvalue: function (row, cellvalue, editor) {
        //   return editor.find('textarea').val();
        // },
      },
      {
        text: 'Address', width: '6%', datafield: 'Change', columntype: 'custom',
        createeditor: (row: number, value: any, editor: any): void => {
          var textBox = $("<button class='jqx-rc-all jqx-button jqx-widget jqx-element-container jqx-fill-state-normal jqx-primary' id='linkButton' title='Double click to edit the Address'> Update </button>").appendTo(editor);
          $(textBox).click(function () {
            setTimeout(function () {
              $('#addressGrid1').jqxGrid('selectrow', row);
              compScope.OpenAddress(row);
            }, 0);
          })
        },
        cellsrenderer: function (row) {
          return "<button class='jqx-rc-all jqx-button jqx-widget jqx-element-container jqx-fill-state-normal jqx-primary' id='linkButton' title='Double click to edit the Address'> Update </button>";
        },
        buttonclick: function (row) {
          $('#addressGrid1').jqxGrid('selectrow', row);
          compScope.OpenAddress(row);
        },
      },
      {
        text: 'City', datafield: 'City', width: '10%', height: 80, editable: true, hidden: true,
        initeditor: function (row, column, editor) {
          editor.attr('maxlength', 30);
        }
      },

      {
        text: 'Country <span style="color:red">*</span>', height: 80, width: '10%', datafield: 'CountryName', columntype: 'custom',
        createeditor: (row: number, cellvalue: any, editor: any, cellText: any, width: any, height: any): void => {
          countryNameLabelInput = this.gridService.gridAutoCompleteCreateEditor(row, cellvalue, editor, cellText, width, height, countryurl, 'CountryName');
        },
        initeditor: (row: number, cellvalue: any, editor: any, celltext: any, pressedkey: any): void => {
          this.gridService.gridAutoCompleteInitEditor(row, cellvalue, editor, celltext, pressedkey, countryNameLabelInput);
        },
        geteditorvalue: (row: number, cellvalue: any, editor: any): void => {
          return this.gridService.gridAutoCompleteGeteditorvalue(row, cellvalue, editor, this.addressGrid1, 'CountryId', countryNameLabelInput);
        },
        validation: function (_cell, valueMember, _row) {

          if (valueMember === "") {
            return { message: "Country is Required" };
          } else {
            scope.ctryName = valueMember;

            return true;
          }

        },
      },

      {
        text: 'State', width: '10%', height: 80, datafield: 'StateName', columntype: 'custom',
        createeditor: (row: number, cellvalue: any, editor: any, cellText: any, width: any, height: any): void => {
          stateNameLabelInput = this.gridService.gridAutoCompleteCreateEditor(row, cellvalue, editor, cellText, width, height, stateurl, 'StateName');
        },
        initeditor: (row: number, cellvalue: any, editor: any, celltext: any, pressedkey: any): void => {
          this.gridService.gridAutoCompleteInitEditor(row, cellvalue, editor, celltext, pressedkey, stateNameLabelInput);
        },
        geteditorvalue: (row: number, cellvalue: any, editor: any): void => {
          return this.gridService.gridAutoCompleteGeteditorvalue(row, cellvalue, editor, this.addressGrid1, 'StateID', stateNameLabelInput);
        },
        validation: function (_cell, valueMember, _row) {
          if (this.ctryName == "INDIA") {
            if (valueMember === "") {
              return { message: "State is Required" };
            }
          } else {

            return true;
          }

        },
      },
      { text: 'StateID', datafield: 'StateID', width: '10%', editable: true, hidden: true },

      {
        text: 'GST', datafield: 'Province', height: 80, width: '10%', editable: true,
        initeditor: function (row, column, editor) {
          editor.attr('maxlength', 15);
        }
      },

      { text: 'CountryId', datafield: 'CountryId', width: '10%', editable: true, hidden: true },

      {
        text: 'Sales Person', datafield: 'ZipCode', width: '10%', height: 80, editable: true, columntype: 'numberinput',
        initeditor: function (row, column, editor) {
          editor.attr('maxlength', 6);
        }
      },

      {
        text: 'Contact Person', datafield: 'PIC', width: '10%', height: 80, editable: true,
        initeditor: function (row, column, editor) {
          editor.attr('maxlength', 50);
        }
      },

      {
        text: 'Phone No', datafield: 'Phone', width: '15%', height: 80, editable: true,
        initeditor: function (row, column, editor) {
          editor.attr('maxlength', 13);
        }
      },

      {
        text: 'Email', datafield: 'Email', width: '15%', height: 80, editable: true,
        initeditor: function (row, column, editor) {
          editor.attr('maxlength', 100);
        }
      },

      {
        text: 'Pan No', datafield: 'PAN', width: '15%', height: 80, editable: true,
        initeditor: function (row, column, editor) {
          editor.attr('maxlength', 10);
        }
      },

      // {
      //   text: 'GST No <span style="color:red">*</span>', height: 80, datafield: 'GSTNo', width: '15%', editable: true, hidden: true,
      //   initeditor: function (row, column, editor) {
      //     editor.attr('maxlength', 15);
      //   }
      // },

      {
        text: 'TAN No', datafield: 'TANNo', width: '15%', height: 80, editable: true,
        initeditor: function (row, column, editor) {
          editor.attr('maxlength', 25);
        }
      },

      {
        text: 'ARN No', datafield: 'ARNNo', width: '14%', height: 80, editable: true,
        initeditor: function (row, column, editor) {
          editor.attr('maxlength', 15);
        }
      },
      {
        text: 'isSEZ', datafield: 'isSEZ', width: '5%', height: 80, cellbeginedit: compScope.cellbeginedit, columntype: 'custom', align: "center", font: "bold", menu: false, sortable: false,
        createeditor: (row: number, cellvalue: any, editor: any, cellText: any, width: any, height: any): void => {
          checkbox = document.createElement('input');
          checkbox.type = "checkbox";
          checkbox.name = "isSEZ";
          checkbox.className = "gridActiveCheckBox"
          checkbox.id = "isSEZ" + row;
          checkbox.checked = cellvalue === 1;
          checkbox.addEventListener("click", function () {
            var Invval = $(".addressGrid1").jqxGrid('getcellvalue', row, 'InvoiceNumber');
            checkbox.checked = cellvalue === 1;
          });
          editor[0].appendChild(checkbox);
        },
        initeditor: (row: number, cellvalue: any, editor: any, celltext: any, pressedkey: any): void => {
          $("#isSEZ" + row).focus();
        },
        geteditorvalue: (row: number, cellvalue: any, editor: any): number => {
          // return the editor's value
          return $(editor).find('input[type="checkbox"]').is(':checked') ? 1 : 0;
        },

        cellsrenderer: function (row, cell, value) {
          return compScope.generateCheckBox(row, cell, value);
        }
      },
    ];
    let addressTypeIdCombo = this.addressTypeIdComboAddapter && this.addressTypeIdComboAddapter.records ? this.addressTypeIdComboAddapter.records : [{ Label: "", Value: "" }];
    this.addressSource =
    {
      datatype: 'json',
      datafields: [
        { name: 'sNo', type: 'int' },
        { name: 'CuDetailId', type: 'int' },
        { name: 'CustomerId', type: 'int' },
        { name: 'AddressTypeName', value: 'AddressType', values: { source: addressTypeIdCombo, value: 'Value', name: 'Label' } },
        { name: 'AddressType', type: 'int' },
        { name: 'Address', type: 'String' },
        { name: 'City', type: 'string' },
        { name: 'StateName', type: 'string' },
        { name: 'StateID', type: 'int' },
        { name: 'Province', type: 'string' },
        { name: 'CountryName', type: 'string' },
        { name: 'CountryId', type: 'int' },

        { name: 'ZipCode', type: 'string' },
        { name: 'PIC', type: 'string' },
        { name: 'Phone', type: 'string' },
        { name: 'Email', type: 'string' },
        { name: 'PAN', type: 'string' },
        { name: 'GSTNo', type: 'string' },
        { name: 'TANNo', type: 'string' },
        { name: 'ARNNo', type: 'string' },
        { name: 'isActive', type: 'int' },
        { name: 'isSEZ', type: 'int' },
        { name: 'Branch', type: 'string' },

        

      ],
      id: 'uid',
      rowdetails: true,
      rowdetailstemplate: { rowdetails: '<div style="margin: 10px; height: 100px !important"></div>', rowdetailsheight: 100 },
      localdata: [
        {
          Branch: "TUT", CuDetailId: "", CustomerId: "", isActive: "", AddressType: "", AddressTypeName: "", Address: "", City: "", StateName: "", StateID: "", Province: "",
          CountryName: "", CountryId: "", ZipCode: "", PIC: "", Phone: "", Email: "", PAN: "", GSTNo: "", TANNo: "", ARNNo: ""
        }
      ]
    };

    this.addressGridToolBar = (toolbar: any): void => {
      if (!this.commonService.isEmpty(toolbar)) {
        let buttonIdObj = {
          add: 'addressAdd',
          delete: 'addressDelete',
          // download: 'addressDownload',
        }
        let tooBarObj = {
          currenComponentObj: this,
          gridObj: this.addressGrid1,
          toolbarObj: toolbar,
          // gridTitle: "Container Details",
          buttonObj: buttonIdObj,
          addRowMethodObj: this.addAddressNewRow,
          deleteRowMethodObj: this.deleteRowAddressGrid,
          // downloadGridMethodObj: this.downloadMechanic,
        }
        this.gridService.generateToolBar(tooBarObj);
      };
    }
    this.addressGridDataAdapter = new jqx.dataAdapter(this.addressSource);
  }
  generateCheckBox(row, cell, value) {
    if (value == 1) {
      return '<input type="checkbox" value="' + value + '" class="gridActiveCheckBox" Checked>';
    } else {
      return '<input type="checkbox" value="' + value + '" class="gridActiveCheckBox">';
    }
  }
  cellbeginedit = function (row, datafield, columntype, value) {
    return true;
    // var Invval = $(".addressGrid1").jqxGrid('getcellvalue', row, 'InvoiceID');
    // if (Invval == null || Invval == '') { return true } else { return false };
  }
  addAddressNewRow(obj) {
    let row = {};
    row['CuDetailId'] = ''
    row['CustomerId'] = ''
    row['isActive'] = ''
    row['AddressType'] = ''
    // row['AddressTypeName'] = ''
    row['Address'] = ''
    row['City'] = ''
    row['StateName'] = ''
    row['StateID'] = ''
    row['Province'] = ''
    row['CountryName'] = ''
    row['CountryId'] = ''
    row['ZipCode'] = ''
    row['PIC'] = ''
    row['Phone'] = ''
    row['Email'] = ''
    row['PAN'] = ''
    row['GSTNo'] = ''
    row['TANNo'] = ''
    row['ARNNo'] = ''

    return row;
  }
  onAddressGridCellBeginEdit(event) {
    let args = event.args;
    let columnDataField = args.datafield;
    let rowIndex = args.rowindex;
    let cellValue = args.value;
  }
  onAddressGridCellEndEdit(event) {
    let args = event.args;
    let columnDataField = args.datafield;
    let rowIndex = args.rowindex;
    let cellValue = args.value;
    let oldValue = args.oldvalue;
    this.addressGrid1.setcellvalue(rowIndex, columnDataField, cellValue);
  }


  deleteRowAddressGrid(obj) {
    // obj.deleteCommodityDetails = [];
    let selectedrowindex = obj.addressGrid1.getselectedrowindex();
    let selectedrowindexes = obj.addressGrid1.getselectedrowindexes();
    let rowscount = obj.addressGrid1.getdatainformation().rowscount;
    if (selectedrowindexes.length > 0) {
      if (Number(rowscount) > 0) {
        let deleteRows: any = [];
        selectedrowindexes.forEach(index => {
          let id = obj.addressGrid1.getcellvalue(selectedrowindex, 'CuDetailId')
          let rowAlreadyExits = false;
          if (id) {
            var rowData = obj.addressGrid1.getrowdata(index)

            obj.deleteMechanicDetails.push(rowData);
            let rowId = obj.addressGrid1.getrowid(index);
            deleteRows.push(rowId);

          } else {
            let rowId = obj.addressGrid1.getrowid(index);
            deleteRows.push(rowId);
          }


        }); console.log(obj.deleteMechanicDetails);
        if (deleteRows.length > 0) {
          obj.addressGrid1.deleterow(deleteRows);
          let rowscountAfterDelete = obj.addressGrid1.getdatainformation().rowscount;
          console.log(rowscountAfterDelete);
          if (rowscountAfterDelete == 0) {
            obj.addressGrid1.clear();
            let datarow = obj.addAddressNewRow(obj);
            obj.addressGrid1.addrow(null, datarow);
          }
        }
      } else {
        // obj.sacFilingGrid.clear();
        // let datarow = obj.addAddressNewRow(obj);
        // obj.sacFilingGrid.addrow(null, datarow);
      }
    } else {
      obj.alert.openSnackBar("No row selected", '');
    }

  }
  public countryParams(value) {
    return new Promise((res) => {
      res({ value: value });
    });
  }

  getAddressTypeId() {
    return new Promise((resolve, reject) => {
      let addressTypeIds: any[] = [];
      this.http.get(this.masteruri + '/item-activity/combo', { params: { value: "Address Type" } }).subscribe(
        value => {
          addressTypeIds = value as any[];
          let stateSource: any =
          {
            datatype: 'json',
            datafields: [
              { name: 'Label', type: 'string' },
              { name: 'Value', type: 'int' }
            ],
            localdata: addressTypeIds
          };
          this.addressTypeIdComboAddapter = new jqx.dataAdapter(stateSource, { autoBind: true });
          resolve(this.addressTypeIdComboAddapter);

        });
    });
  }

  onCustomerNamegChanged() {
    var frmObj = this.customerMasterForm.getRawValue();
    let cname = frmObj.CuName;
    if (cname.includes("M/S") || cname.includes("m/s") || cname.includes("M/s")) {
      this.customerMasterForm.get("CuName").setValue("");
    }
  }
  //#region Save Function

  saveCustomer() {
    //this.alert.openSnackBar("Hello", "");
    this.StateFlag = true;
    this.GstFlag = true;


    this.progressBarShow = true;
    var scope = this;
    var frmObj = this.customerMasterForm.getRawValue();
    frmObj.createdId = this.createdId;
    frmObj.createdMacAddress = this.createdMacAddress;
    frmObj.modifiedId = this.createdId;
    frmObj.modifiedMacAddress = this.createdMacAddress;
    if (!frmObj.TDSPer || frmObj.TDSPer == '') {
      delete frmObj.TDSPer;
    }
    if (!frmObj.TDSID || frmObj.TDSID == '') {
      delete frmObj.TDSID;
    }
    let detailGridData: Array<any> = [];
    var rows = $('.addressGrid1').jqxGrid('getboundrows');
    var kyc = $('.imageUploadDetailsGrid').jqxGrid('getboundrows');

    rows.forEach(address => {
      if (address.AddressType == null) {
        address.AddressType = '';
      }
      if (address.Address == null) {
        address.Address = '';
      }
      //address.Address = this.stripHTML(address.Address);
      if (address.City == null) {
        address.City = '';
      }
      if (address.CountryName == null) {
        address.CountryName = '';
      }
      if (!address.isSEZ) {
        address.isSEZ = 0;
      }
      if (address.isSEZ == null) {
        address.isSEZ = 0;
      }
      if (address.isSEZ == '') {
        address.isSEZ = 0;
      }
      if (!address.HandleByID) {
        address.HandleByID = '';
      }


      // if (address.StateName == null) { 
      //   address.StateName


      // }

      if (address.CountryName == "INDIA") {
        if (address.StateName == null || !address.StateName)
          this.StateFlag = false;
      } else if (address.StateName == null) {
        address.StateName = '';
      }
      if (address.StateID == null) {
        address.StateID = '';
      }
      if (address.Province == null) {
        address.Province = '';
      }
      if (address.CountryId == null) {
        address.CountryId = '';
      }
      if (address.PIC == null) {
        address.PIC = '';
      }
      if (address.Phone == null) {
        address.Phone = '';
      }
      if (address.Email == null) {
        address.Email = '';
      }
      if (address.PAN == null) {
        address.PAN = '';
      }
      if (address.GSTNo == null) {
        address.GSTNo = '';
      }
      if (address.GST == null) {
        address.GST = '';
      }

      if (address.TANNo == null) {
        address.TANNo = '';
      }
      if (address.ARNNo == null) {
        address.ARNNo = '';
      }
    });

    kyc.forEach(kycDetails => {
      if (kycDetails.DocumentID == null) {
        kycDetails.DocumentID = '';
      }
      if (kycDetails.DocRefNumber == null) {
        kycDetails.DocRefNumber = '';
      }
      if (kycDetails.StoredFileName == null) {
        kycDetails.StoredFileName = '';
      }
    });

    var filtered = rows.filter(function (el) {
      return el != null && el != 0 && el != null;
    });
    filtered.forEach(element => {
      element.isActive = 0;
      element.GSTNo = '';
      element.createdId = this.createdId;
      element.createdMacAddress = this.createdMacAddress;
      element.modifiedId = this.createdId;
      element.modifiedMacAddress = this.createdMacAddress;
    });

    var customerType = '';
    if (frmObj.isCustomer) {
      if (customerType.length == 0) {
        customerType = customerType.concat('1396');
      }
    }
    else {
      frmObj.isCustomer = 0;
    }
    if (frmObj.isOMSAgent) {
      if (customerType.length == 0) {
        customerType = customerType.concat('1412');
      }
    }
    else {
      frmObj.isOMSAgent = 0;
    }

    if (frmObj.isShipper) {
      if (customerType.length == 0) {
        customerType = customerType.concat('31');
      }
    }
    else {
      frmObj.isShipper = 0;
    }
    if (frmObj.isForwarder) {
      if (customerType.length == 0) {
        customerType = '214'
      } else {
        customerType = customerType.concat(',');
        customerType = customerType.concat('214');
      }
    }
    else {
      frmObj.isForwarder = 0;
    }
    if (frmObj.isCha) {
      if (customerType.length == 0) {
        customerType = '16'
      } else {
        customerType = customerType.concat(',');
        customerType = customerType.concat('16');
      }
    }
    else {
      frmObj.isCha = 0;
    }
    if (frmObj.isLiner) {
      if (customerType.length == 0) {
        customerType = '216'
      } else {
        customerType = customerType.concat(',');
        customerType = customerType.concat('216');
      }
    }
    else {
      frmObj.isLiner = 0;
    }
    if (frmObj.isTransporter) {
      if (customerType.length == 0) {
        customerType = '20'
      } else {
        customerType = customerType.concat(',');
        customerType = customerType.concat('20');
      }
    }
    else {
      frmObj.isTransporter = 0;
    }
    if (frmObj.isTrader) {
      if (customerType.length == 0) {
        customerType = '220'
      } else {
        customerType = customerType.concat(',');
        customerType = customerType.concat('220');
      }
    }
    else {
      frmObj.isTrader = 0;
    }
    if (frmObj.isAgent) {
      if (customerType.length == 0) {
        customerType = '332'
      } else {
        customerType = customerType.concat(',');
        customerType = customerType.concat('332');
      }
    }
    else {
      frmObj.isAgent = 0;
    }
    if (frmObj.isBank) {
      if (customerType.length == 0) {
        customerType = '222'
      } else {
        customerType = customerType.concat(',');
        customerType = customerType.concat('222');
      }
    }
    else {
      frmObj.isBank = 0;
    }
    if (frmObj.isConsignee) {
      if (customerType.length == 0) {
        customerType = '372'
      } else {
        customerType = customerType.concat(',');
        customerType = customerType.concat('372');
      }
    }
    else {
      frmObj.isConsignee = 0;
    }
    if (frmObj.isNotifier) {
      if (customerType.length == 0) {
        customerType = '373'
      } else {
        customerType = customerType.concat(',');
        customerType = customerType.concat('373');
      }
    }
    else {
      frmObj.isNotifier = 0;
    }
    if (frmObj.isContract) {
      if (customerType.length == 0) {
        customerType = '376'
      } else {
        customerType = customerType.concat(',');
        customerType = customerType.concat('376');
      }
    }
    else {
      frmObj.isContract = 0;
    }
    if (frmObj.isDomesticVendor) {
      if (customerType.length == 0) {
        customerType = '389'
      } else {
        customerType = customerType.concat(',');
        customerType = customerType.concat('389');
      }
    }
    else {
      frmObj.isDomesticVendor = 0;
    }
    if (frmObj.isWarehouse) {
      if (customerType.length == 0) {
        customerType = '390'
      } else {
        customerType = customerType.concat(',');
        customerType = customerType.concat('390');
      }
    }
    else {
      frmObj.isWarehouse = 0;
    }
    //////
    if (frmObj.isImportNotifier) {
      if (customerType.length == 0) {
        customerType = '1395'
      } else {
        customerType = customerType.concat(',');
        customerType = customerType.concat('1395');
      }
    }
    else {
      frmObj.isImportNotifier = 0;
    }

    if (frmObj.isImportConsignee) {
      if (customerType.length == 0) {
        customerType = '1394'
      } else {
        customerType = customerType.concat(',');
        customerType = customerType.concat('1394');
      }
    }
    else {
      frmObj.isImportConsignee = 0;
    }

    if (frmObj.isImportShipper) {
      if (customerType.length == 0) {
        customerType = '1393'
      } else {
        customerType = customerType.concat(',');
        customerType = customerType.concat('1393');
      }
    }
    else {
      frmObj.isImportShipper = 0;
    }
    //////
    frmObj.CuType = customerType;
    frmObj.Detail = filtered;
    if (frmObj.CustomerId == null) {
      frmObj.CustomerId = 0;
      frmObj.CreatedBy = this.property.userId;
    } else {
      frmObj.UpdatedBy = this.property.userId;
    }
    if (!frmObj.CustomerId) {
      frmObj.CustomerId = 0;
      frmObj.CreatedBy = this.property.userId;
    } else {
      frmObj.UpdatedBy = this.property.userId;
    }
    if (frmObj.BaseCurrency == null) {
      frmObj.BaseCurrency = '';
    }

    if (frmObj.CountryId == null) {
      frmObj.CountryId = '';
    }
    if (frmObj.TermCode == null) {
      frmObj.TermCode = '';
    }
    if (!frmObj.TermCode) {
      frmObj.TermCode = 0;
    }
    if (!frmObj.AcType || frmObj.AcType == null || frmObj.AcType == 'null' || frmObj.AcType == "null") {
      frmObj.AcType = '';
    }

    if (frmObj.CurrencyId == null) {
      frmObj.CurrencyId = '';
    }

    if (frmObj.PaymentType == null) {
      frmObj.PaymentType = '';
    }
    if (!frmObj.PaymentType || frmObj.PaymentType == null || frmObj.PaymentType == 'null') {
      frmObj.PaymentType = '';
    }
    if (!frmObj.BenAcType || frmObj.BenAcType == null || frmObj.BenAcType == 'null') {
      frmObj.BenAcType = '';
    }
    if (!frmObj.Currency) {
      frmObj.Currency = '';
    }
    if (!frmObj.FSCBilling) {
      frmObj.FSCBilling = 0;
    }

    if (!frmObj.TDSPercentage) {
      frmObj.TDSPercentage = 0;
    }

    if (!frmObj.ProfitShare) {
      frmObj.ProfitShare = 0;
    }

    if (frmObj.EffectiveDt == null) {
      frmObj.EffectiveDt = '';
    }

    if (frmObj.CuName == null) {
      frmObj.CuName = '';
    }

    if (frmObj.SplAccounts == null) {
      frmObj.SplAccounts = '';
    }

    if (frmObj.GstExempted == null) {
      frmObj.GstExempted = '';
    }

    if (frmObj.TaxIdNo == null) {
      frmObj.TaxIdNo = '';
    }

    if (frmObj.CreditDays == null) {
      frmObj.CreditDays = '';
    }
    if (frmObj.GST == null) {
      frmObj.GST = '';
    }
    if (frmObj.Note == null) {
      frmObj.Note = '';
    }

    if (frmObj.AcOprPerson == null) {
      frmObj.AcOprPerson = '';
    }
    if (frmObj.BillSubLedger == null) {
      frmObj.BillSubLedger = '';
    }

    if (frmObj.EDirect == null) {
      frmObj.EDirect = '';
    }

    if (frmObj.EImport == null) {
      frmObj.EImport = '';
    }

    if (frmObj.ETranshipment == null) {
      frmObj.ETranshipment = '';
    }

    if (frmObj.EImportstatus == null) {
      frmObj.EImportstatus = '';
    }

    if (frmObj.EExport == null) {
      frmObj.EExport = '';
    }

    if (frmObj.EAutoOS == null) {
      frmObj.EAutoOS = '';
    }

    if (frmObj.EExportstatus == null) {
      frmObj.EExportstatus = '';
    }

    if (frmObj.BankName == null) {
      frmObj.BankName = '';
    }

    if (frmObj.AccountNo == null) {
      frmObj.AccountNo = '';
    }

    if (frmObj.AccountName == null) {
      frmObj.AccountName = '';
    }

    if (frmObj.IFSC == null) {
      frmObj.IFSC = '';
    }

    if (frmObj.SwiftNo == null) {
      frmObj.SwiftNo = '';
    }

    if (frmObj.RoutingNo == null) {
      frmObj.RoutingNo = '';
    }

    if (frmObj.BankAddress == null) {
      frmObj.BankAddress = '';
    }

    if (frmObj.BeneficiaryName == null) {
      frmObj.BeneficiaryName = '';
    }

    if (frmObj.BenAcNo == null) {
      frmObj.BenAcNo = '';
    }

    if (frmObj.BenAddress == null) {
      frmObj.BenAddress = '';
    }

    if (frmObj.BenMobile == null) {
      frmObj.BenMobile = '';
    }

    if (frmObj.isActive) {
      frmObj.isActive = 1;
    }
    if (frmObj.isFactoring) {
      frmObj.isFactoring = 0;
    } else {
      frmObj.isFactoring = 1;
    }
    if (frmObj.upload == null) {
      frmObj.upload = '';
    }
    if (frmObj.SalesPersonID == null) {
      frmObj.SalesPersonID = '';
    }
    if (!frmObj.SalesPersonID) {
      frmObj.SalesPersonID = 0;
    }
    frmObj.KYC = kyc;

    if (frmObj.Country == "INDIA") {
      if (frmObj.GST == "" || frmObj.GST == null || !frmObj.GST) {
        this.alert.openSnackBar('GST is Required for INDIA', '');
        this.GstFlag = false
      }
    }
    else {
      this.GstFlag = true
    }
    let validationsaleperson = true;
    let validationMessage = "";
    frmObj.BranchCode = this.property.branchCode;
    if (this.isSalesPersonRequired == 1) {
      if (!frmObj.SalesPersonID || frmObj.SalesPersonID == 0) {
        validationsaleperson = false;
        validationMessage = "Enter Sales Person Name";
      } else {
        validationsaleperson = true;
      }
    }

    if (rows.length > 0 && this.StateFlag && this.GstFlag) {



      var SpecificationGridMondatoryValidation = this.AddressCheckGridMondatory(".addressGrid1", ['AddressType', 'CountryName'], this.addressGrid1)


      if (SpecificationGridMondatoryValidation) {
        if (validationsaleperson) {
          var header = { 'Accept': 'application/json', 'Content-Type': 'application/json' }
          console.log(frmObj);
          this.httpRequestService.post(this.masteruri + "/org/load", frmObj, header).then((response: any) => {
            if (response.status == 200) {
              if (response.result[0].ID == -1) {
                this.alert.openSnackBar(response.result[0].Message, '0');
              } else {
                this.alert.openSnackBar(response.result[0].Message, '1');
                this.clear();
                this.StateFlag = true;
                this.GstFlag = true;
                this.addressGridInit();
                this.searchService.refreshSearch();
              }
              this.progressBarShow = false;

            } else if (response.status == 400) {
              this.progressBarShow = false;
              this.alert.openSnackBar(response.result, '0');
            }
          }, (error: any) => {
            console.log('ou save Error Occured', error);
          });
        } else {
          this.alert.openSnackBar(validationMessage, '0');
          this.progressBarShow = false;
        }

      }
      // }   

    }
    else {
      this.progressBarShow = false;
      if (!this.GstFlag) {
        this.alert.openSnackBar('GST is Required For India', '');
      } else {
        this.alert.openSnackBar('State is Required For India', '');
      }
    }


  }

  //#endregion

  deleteRowMechanicGrid(obj) {
    // obj.deleteCommodityDetails = [];
    let selectedrowindex = obj.addressGrid1.getselectedrowindex();
    let selectedrowindexes = obj.addressGrid1.getselectedrowindexes();
    let rowscount = obj.addressGrid1.getdatainformation().rowscount;
    if (selectedrowindexes.length > 0) {
      if (Number(rowscount) > 0) {
        let deleteRows: any = [];
        selectedrowindexes.forEach(index => {
          let id = obj.addressGrid1.getcellvalue(selectedrowindex, 'id')
          let rowAlreadyExits = false;
          if (id) {
            var rowData = obj.addressGrid1.getrowdata(index)

            obj.deleteMechanicDetails.push(rowData);
            let rowId = obj.addressGrid1.getrowid(index);
            deleteRows.push(rowId);

          } else {
            let rowId = obj.addressGrid1.getrowid(index);
            deleteRows.push(rowId);
          }


        }); console.log(obj.deleteMechanicDetails);
        if (deleteRows.length > 0) {
          obj.addressGrid1.deleterow(deleteRows);
          let rowscountAfterDelete = obj.addressGrid1.getdatainformation().rowscount;
          console.log(rowscountAfterDelete);
          if (rowscountAfterDelete == 0) {
            obj.addressGrid1.clear();
            let datarow = obj.addTerminalNewRow(obj);
            obj.addressGrid1.addrow(null, datarow);
          }
        }
      } else {
        // obj.sacFilingGrid.clear();
        // let datarow = obj.addAddressNewRow(obj);
        // obj.sacFilingGrid.addrow(null, datarow);
      }
    } else {
      obj.alert.openSnackBar("No row selected", '');
    }

  }

  cargoDamageDetailsGrid() {
    var compScope = this;
    this.imageUploadDetailsColumns =
      [
        {
          text: 'S.No', width: '8%', sortable: false, menu: false,
          cellsrenderer: function (row, cell, value) {
            return '<div style="text-align: center; margin-top: 5px;">' + (1 + row) + '</div>';
          }
        },
        {
          text: 'Code <span style="color:red">*</span>', datafield: 'DocumentID', displayfield: 'codeName', width: '20%', editable: true, columntype: 'dropdownlist',
          createeditor: (row: number, value: any, editor: any): void => {
            editor.jqxDropDownList({
              source: this.IsCodeComboAdapter,
              displayMember: 'Label',
              valueMember: 'Value',
              autoDropDownHeight: this.IsCodeComboAdapter.length > 10 ? false : true
            });
          }
        },
        {
          text: 'Ref No', datafield: 'DocRefNumber', width: '22%'
        },
        { text: 'File Name <span style="color:red">*</span>', datafield: 'StoredFileName', displayfield: 'FileName', width: '43%', editable: false },
        {
          text: 'Preview <span style="color:red">*</span>', width: '10%', datafield: 'Download', columntype: 'custom',
          createeditor: (row: number, value: any, editor: any): void => {
            var textBox = $("<button class='jqx-rc-all jqx-button jqx-widget jqx-element-container jqx-fill-state-normal jqx-primary' id='linkButton'> Preview </button>").appendTo(editor);
            $(textBox).click(function () {
              setTimeout(function () {
                $('#imageUploadDetailsGrid').jqxGrid('selectrow', row);
                compScope.imageDownload(row);
              }, 0);
            })
          },
          cellsrenderer: function (row) {
            return "<button class='jqx-rc-all jqx-button jqx-widget jqx-element-container jqx-fill-state-normal jqx-primary' id='linkButton'> Preview </button>";
          },
          buttonclick: function (row) {
            $('#imageUploadDetailsGrid').jqxGrid('selectrow', row);
            compScope.imageDownload(row);
          },
        },

        { text: 'isActive', hidden: true, datafield: 'isActive' },
        { text: 'CKyCID', hidden: true, datafield: 'CKyCID' },
        { text: 'CustomerId', hidden: true, datafield: 'CustomerId' }
      ];
    let rows = [];
    // let Delrows = [];
    // this.data.result.forEach((ele) => {
    //   if (ele.isActive === 1) {

    //   // if (element.isActive === 1) {
    //     rows.push(ele);
    //   } else {
    //     this.deletedObjects.push(ele);
    //   }
    // });
    //   // } else {
    //     // Delrows.push(ele);
    //   }

    // this.deletedGridRowList = Delrows;
    let IsCodeCombo = this.IsCodeComboAdapter && this.IsCodeComboAdapter.records ? this.IsCodeComboAdapter.records : [{ Label: "", Value: "" }];
    this.imageUploadDetailsSource =
    {
      datatype: 'json',
      datafields: [
        // { name: 'id', type: 'int' },
        { name: 'codeName', value: 'code', values: { source: IsCodeCombo, value: 'Value', name: 'Label' } },
        { name: 'DocumentID', type: 'int' },
        { name: 'FileName', type: 'string' },
        { name: 'StoredFileName', type: 'string' },
        { name: 'DocRefNumber', type: 'string' },
        { name: 'isActive', type: 'int' },
        { name: 'CKyCID', type: 'int' },
        { name: 'CustomerId', type: 'int' },
      ],
      id: 'uid',
      localdata: [{
        isActive: 1,
        codeName: "",
        code: "", DocumentID: "", FileName: "", StoredFileName: "", DocRefNumber: "", CKyCID: "", CustomerId: ""

      }]
    };

    this.gateInContSealImagePopupRenderToolBar = (toolbar: any): void => {
      if (!this.commonService.isEmpty(toolbar)) {
        let buttonIdObj = {
          add: 'imageAdd',
          delete: 'contSealImageDelete',
        }
        let tooBarObj = {
          currenComponentObj: this,
          gridObj: this.imageUploadDetailsGrid,
          toolbarObj: toolbar,
          buttonObj: buttonIdObj,
          // gridTitle: "Image Details",
          addRowMethodObj: this.addImageNewRow,
          deleteRowMethodObj: this.deleteSealDetailsGrid
        }
        this.gridService.generateToolBar(tooBarObj);
      };
    }

    this.imageUploadDetailsDataAdapter = new jqx.dataAdapter(this.imageUploadDetailsSource);
  }

  imageDownload(row) {
    // var file = $('.imageUploadDetailsGrid').jqxGrid('getrowdata', row);
    // this.http.get(this.uri + "/imageUpload/downloadFile/" + file.StoredFileName, { responseType: 'arraybuffer' as 'json' })
    //   .subscribe((data: any) => {
    //     // let contentType = data.type
    //     var file = new Blob([data], { type: 'application/octet-stream' });
    //     // var file = new Blob([data], { type: contentType });
    //     var fileURL = URL.createObjectURL(file);
    //     if (fileURL) {
    //       window.open(fileURL);
    //     } else {
    //       this.alert.openSnackBar('File Not Found', '');
    //     }
    //   });
    var file = $('.imageUploadDetailsGrid').jqxGrid('getrowdata', row);
    if (file.StoredFileName) {
      this.http.get(this.uri + "/imageUpload/downloadFile/" + file.StoredFileName)
        .subscribe((data: any) => {
          if (data && data.base64) {
            let binaryString = window.atob(data.base64);
            let binaryLen = binaryString.length;
            let bytes = new Uint8Array(binaryLen);
            for (let i = 0; i < binaryLen; i++) {
              let ascii = binaryString.charCodeAt(i);
              bytes[i] = ascii;
            }
            let file = new Blob([bytes], { type: data.contentType });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          }
        });
    }
  }

  addImageNewRow(obj) {
    let check = $(".imageUploadDetailsGrid").jqxGrid('getboundrows');
    let SpecificationGridMondatoryValidation = obj.gridService.checkGridMondatory(".imageUploadDetailsGrid", ['codeName', 'FileName'])
    if (SpecificationGridMondatoryValidation) {
      let row = {};
      row['codeName'] = ''
      row['code'] = 0
      row['DocumentID'] = ''
      row['FileName'] = ''
      row['StoredFileName'] = ''
      row['DocRefNumber'] = ''
      row['CKyCID'] = ''
      row['CustomerId'] = ''
      row['isActive'] = 1
      return row;
    }
  }
  public userParams(value) {
    return new Promise((res) => {
      res({ searchText: value, Type: 'Sales' });
    });
  }
  public userParamsHandleBy(value) {
    return new Promise((res) => {
      res({ searchText: value, Type: 'Handle' });
    });
  }

  deleteSealDetailsGrid(obj) {
    let selectedrowindex = obj.imageUploadDetailsGrid.getselectedrowindex();
    let selectedrowindexes = obj.imageUploadDetailsGrid.getselectedrowindexes();
    let rowscount = obj.imageUploadDetailsGrid.getdatainformation().rowscount;
    if (selectedrowindexes.length > 0) {
      if (Number(rowscount) > 0) {
        let deleteRows: any = [];
        selectedrowindexes.forEach(index => {
          let id = obj.imageUploadDetailsGrid.getcellvalue(selectedrowindex, 'CKyCID')
          if (id) {
            var rowData = obj.imageUploadDetailsGrid.getrowdata(index)
            rowData.isActive = 0;
            rowData.modifiedId = obj.property.userId;
            rowData.modifiedMacAddress = obj.property.macAddress;
            obj.deletedObjects.push(rowData);
            let rowId = obj.imageUploadDetailsGrid.getrowid(index);
            deleteRows.push(rowId);

          } else {
            let rowId = obj.imageUploadDetailsGrid.getrowid(index);
            deleteRows.push(rowId);
          }

        }); console.log(obj.deletedObjects);
        if (deleteRows.length > 0) {
          obj.imageUploadDetailsGrid.deleterow(deleteRows);
          if (!$(".imageUploadDetailsGrid").jqxGrid('getrows').length) {

            $(".imageUploadDetailsGrid").jqxGrid("clear");
          }

          if (deleteRows[0] === 0) {
            // obj.addressGrid1.clear();
            // let datarow = obj.addTerminalNewRow(obj);
            // obj.addressGrid1.addrow(null, datarow);
            $(".imageUploadDetailsGrid").jqxGrid("addrow", 0, obj.addImageNewRow(obj));
          }
        }
      }
    } else {
      obj.alert.openSnackBar("No row selected", '');
    }

  }

  getCodeCombo() {
    return new Promise((resolve) => {
      let IsoCode: any[] = [];
      this.http.get(this.uri + '/item-activity/combo', { params: { value: "CODE TYPE" } }).subscribe(
        value => {
          this.IsCodeComboList = (value as any).result as any[];
          let damageTypeSource: any =
          {
            datatype: 'json',
            datafields: [
              { name: 'Label', type: 'string' },
              { name: 'Value', type: 'int' }
            ],
            localdata: this.IsCodeComboList
          };
          this.IsCodeComboAdapter = new jqx.dataAdapter(damageTypeSource, { autoBind: true });
          resolve(this.IsCodeComboAdapter);

        });
    });
  }

  setGstProperty(item) {
    if (item) {
      // if (item.Label == "INDIA") {
      //   this.gstDisabled = false;
      //   this.customerMasterForm.get("GST").setValue(null);

      // } else {
      //   this.gstDisabled = true;
      // }
      this.gstDisabled = false;

      //this.getVoyageComboList(item.Value ? item.Value : 0);
    }
  }
  OpenAddress(row) {
    this.temaAddressRow = row;
    let CusData = $(".addressGrid1").jqxGrid('getrowdata', row);
    if (CusData.Address || CusData.Address == '' || CusData.Address == "") {
      let cid = CusData.Address;
      this.customerMasterForm.get('txtAddress').setValue(cid);
      $("#btnopeninsurance").trigger("click");
    } else {
      let cid = CusData[0].Address;
      this.customerMasterForm.get('txtAddress').setValue(cid);
      $("#btnopeninsurance").trigger("click");
    }
  }
  setAddresstoGrid() {
    var frmObj = this.customerMasterForm.getRawValue();
    if (!frmObj.txtAddress) {
      frmObj.txtAddress = '';
    }
    $(".addressGrid1").jqxGrid('setcellvalue', this.temaAddressRow, 'Address', frmObj.txtAddress);
    $("#btncloseinsurance").trigger("click");
  }
}
